<template>
	<div class="sk-select" tabindex="0" :class="classes" @blur="onBlur">
		<div
			class="selected"
			@click="open = !open"
			v-if="model"
			:class="{ placeholder: model.id == null }"
		>
			<span v-html="model.text" v-if="showSelectedOption"></span>
			<i
				:class="[
					iconClasses,
					iconClasses == 'sk-icon-chevron-down flippable' && open
						? 'flipped'
						: ''
				]"
			></i>
		</div>
		<div
			class="options"
			:class="{ 'select-hide': !open }"
			:style="positionStyle"
		>
			<div
				class="option"
				v-for="option of validOptions"
				:key="option.id"
				:class="{
					selected: !showSelectedOption || option.id == model.id
				}"
				@click="selectOption(option)"
			>
				<div class="option-text" v-html="option.text"></div>
			</div>
		</div>
	</div>
</template>

<style scoped>
/* sk-select-input */
.sk-select-input.sk-select {
	height: 50px;
	border: 1px solid var(--gR-white2);
	background: var(--sk-grey-bg);
	width: 100%;
	border-radius: 5px;
	padding: 0 20px;
}

.sk-select-input.sk-select .selected {
	justify-content: space-between;
	width: 100%;
}

.sk-select-input.sk-select > .selected > span,
.sk-select-input.sk-select .option.selected .option-text {
	color: var(--sk-grey3);
}
/**/

/* sk-select-alternate */
.sk-select-alternate.sk-select {
	height: 35px;
	padding: 0 10px;
}

.sk-select-alternate.sk-select .selected {
	font-weight: 600;
	font-size: 12px;
	width: 100%;
	justify-content: space-between;
}

.sk-select-alternate.sk-select > .selected > span,
.sk-select-alternate.sk-select .option.selected .option-text {
	color: var(--gR-base-80);
}

/**/

.sk-select {
	position: relative;
	width: 100%;
	text-align: left;
	outline: none;
	height: 100%;
	display: flex;
	cursor: pointer;
}

.selected i {
	margin-left: 15px;
	transition: 0.35s cubic-bezier(0.58, -0.46, 1, 1.19);
}

.selected {
	align-items: center;
	display: flex;
	font-size: 14px;
}

.selected.placeholder span {
	color: var(--sk-grey2);
}

.options {
	padding: 20px;
	width: 100%;
	color: var(--gR-white);
	border-radius: 5px;
	overflow: hidden;
	position: absolute;
	background: var(--gR-white);
	box-shadow: 0px 1px 4px rgba(136, 136, 136, 0.25);
	z-index: 10000;
	max-height: 300px;
	overflow-y: auto;
}

.option {
	color: var(--sk-grey2);
	cursor: pointer;
	user-select: none;
	font-size: 14px;
}

.option.selected {
	color: var(--sk-grey3);
}

.option + .option {
	margin-top: 30px;
}

.option-text {
	display: flex;
	align-items: center;
	white-space: nowrap;
}

.option:hover {
	color: var(--sk-grey3);
}

.select-hide {
	display: none;
}

.options >>> i {
	margin-right: 20px;
}
</style>

<script>
export default {
	name: "SkDropdownSelect",
	props: {
		position: {
			type: String,
			default: "bottom"
		},
		showSelectedOption: {
			type: Boolean,
			default: true
		},
		options: {
			type: Array,
			required: true
		},
		classes: {
			type: String,
			default: ""
		},
		iconClasses: {
			type: String,
			default: "sk-icon-chevron-down"
		},
		value: {
			type: Object,
			default: null
		}
	},
	data() {
		return {
			open: false
		}
	},
	computed: {
		model: {
			get() {
				return this.value
			},
			set(val) {
				this.$emit("input", val)
			}
		},
		validOptions() {
			return this.options.filter((option) => option.id != null)
		},
		positionStyle() {
			switch (this.position) {
				case "top":
					return {
						left: "0",
						bottom: "calc(100% + 20px)"
					}
				case "bottom":
					return {
						top: "calc(100% + 20px)",
						left: "0"
					}
				case "right":
					return {
						left: "calc(100% + 20px)",
						top: "0"
					}
				case "left":
					return {
						right: "100%",
						top: "0"
					}
			}
		}
	},
	mounted: function () {
		this.reset(this.options)
	},
	methods: {
		selectOption(option) {
			this.open = false
			this.model = option
			this.$emit("selected", option)
		},
		onBlur() {
			this.open = false
		},
		reset(options, option) {
			if (!this.model || this.model.id == undefined) {
				this.model = options && options.length > 0 ? options[0] : null
			} else if (
				options.length > 0 &&
				options.findIndex((val) => val.id == this.model.id) == -1
			) {
				this.model = options[0]
			} else if (option) {
				this.model = option
			}
		}
	},
	watch: {
		options(newVal) {
			this.reset(newVal)
		}
	}
}
</script>